import React from "react";
import CustomModal from "../../../Core/CommonV2/CustomModal";
import CustomButton from "../../../Core/CommonV2/CustomButton";

const DeleteCloseIcon = ({ className = "" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 2L18 18M18 2L2 18"
      stroke="#344054"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const CloseIcon = ({ className = "" }) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5 0.5L0.5 10.5M0.5 0.5L10.5 10.5" stroke="#344054" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);

const DeleteMessageModal = ({ visible, onClose, onDelete }) => {
  return (
    <CustomModal
      visible={visible}
      width="360px"
      onCancel={() => onClose()}
      body={
        <div className="flex flex-col p-4 gap-y-2 w-[360px] h-[136px]">
          <div className="flex justify-between items-start">
            <p className="text-error-700 out-500-14">Delete message?</p>
            <button onClick={() => onClose()} className="w-[20px] h-[20px] flex items-center justify-center">
              {/* <DeleteCloseIcon />
               */}
              <CloseIcon />
            </button>
          </div>
          <p className="out-300-14 text-gray-500 leading-5">
            Are you sure you want to delete this message? This action cannot be undone.
          </p>
          <div className="flex mt-auto items-center gap-x-3 justify-end">
            <CustomButton
              text="Cancel"
              className="bg-transparent text-gray-500"
              height="30px"
              width="64px"
              onClick={onClose}
            />
            <CustomButton
              text="Delete"
              height="30px"
              width="61px"
              className="bg-error-700 border border-error-700 text-white px-[10px] pt-[3px] pb-[7px] rounded-[8px]"
              onClick={onDelete}
            />
          </div>
        </div>
      }
    />
  );
};

export default DeleteMessageModal;